import type { QueryClient } from '@tanstack/react-query';
import Api from './Api';
import { syncThemeFromBrand, type ThemeRules } from './Theme';

/** Apply theme CSS in the browser and keep React Query host/brand caches aligned. */
export function patchBrandThemeCaches(
    queryClient: QueryClient,
    theme: ThemeRules,
    notify = true
) {
    syncThemeFromBrand(theme, notify);
    queryClient.setQueriesData({ queryKey: ['brand'] }, (existing: unknown) => {
        if (!existing || typeof existing !== 'object' || !('data' in existing)) {
            return existing;
        }
        const response = existing as { data?: Record<string, unknown> };
        if (!response.data) {
            return existing;
        }
        return {
            ...response,
            data: {
                ...response.data,
                theme
            }
        };
    });

    const hostname = window.location.hostname.toLowerCase();
    queryClient.setQueryData(['host', hostname], (existing: unknown) => {
        if (!existing || typeof existing !== 'object' || !('data' in existing)) {
            return existing;
        }
        const response = existing as { data?: Record<string, unknown> };
        if (!response.data) {
            return existing;
        }
        return {
            ...response,
            data: {
                ...response.data,
                theme
            }
        };
    });

    if (Api.hostInfo && typeof Api.hostInfo === 'object') {
        Api.hostInfo = { ...Api.hostInfo, theme };
    }
}
